export default "__VITE_ASSET__gH__ItKX__"